import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ReturnService } from '../../../return.service';
import { Subscription } from 'rxjs';

export interface ICellRendererParamsForReturnAssetListGridAction extends ICellRendererParams {
    viewDetails: (params: ICellRendererParamsForReturnAssetListGridAction) => void;
    isCellRendererHiddenFn?: (value: number, data: any) => boolean;
}

@Component({
    selector: 'return-asset-list-grid-action-cell',
    template:
        `@if (returnAsset && !isHidden()) {
            <button class="ace-btn btn-primary has-icon grid-action-button"
                    title="View Details"
                    (click)="onViewDetailsClicked()">
                <i class="fa fa-pencil"></i>
            </button>
        }`,
    standalone: false
})

export class ReturnAssetListGridActionCellRendererComponent implements ICellRendererAngularComp, OnDestroy {
    constructor(
        private _returnService: ReturnService) {
    }

    returnAsset: Compliance.ReturnAssetModel;
    isReadOnly: boolean = false;

    private _params: ICellRendererParamsForReturnAssetListGridAction;
    private _returnReadOnlyFlagSub: Subscription;

    agInit(params: ICellRendererParamsForReturnAssetListGridAction): void {
        this._returnReadOnlyFlagSub = this._returnService.isReturnInReadOnlyMode$.subscribe(x => this.isReadOnly = x);
        this.isReadOnly = this._returnService.isReturnInReadOnlyMode;
        this._params = params;
        this.returnAsset = params.data as Compliance.ReturnAssetModel;
    }

    ngOnDestroy(): void {
        this._returnReadOnlyFlagSub.unsubscribe();
    }

    isHidden(): boolean {
        return this._params && this._params.isCellRendererHiddenFn && this._params.isCellRendererHiddenFn(this._params.value, this._params.data);
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onViewDetailsClicked(): void {
        this._params.viewDetails(this._params);
    }
}
